import { CreateApiKeyFormType } from 'data/Form/ApiKey/types'
import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

export const getKeys = () =>
  fetchApi<void>({
    auth: true,
    method: 'GET',
    url: getApiUrl('auth/api/key/list')
  })

export const activateKey = (id: string) =>
  fetchApi<void>({
    method: 'PUT',
    url: getApiUrl(`auth/api/key/activate/${id}`)
  })

export const createKey = (body: CreateApiKeyFormType) =>
  fetchApi<void>({
    auth: true,
    body,
    method: 'POST',
    url: getApiUrl('auth/api/key/generate')
  })

export const deactivateKey = (keyId: string, challengeId?: string) =>
  fetchApi<void>({
    auth: true,
    body: {
      challengeId,
      id: keyId,
      type: 'INDIVIDUAL'
    },
    method: 'POST',
    url: getApiUrl('auth/api/key/revoke')
  })
